export function getIcColor(isGray: boolean): string {
  return isGray ? '#8F95A4' : '#2F3778'
}
